import { CtaLink } from "../CtaLink";
import { Paraphe } from "../art/Paraphe";
import { DossierScene } from "./DossierScene";
import { BRAND } from "../brand";

const rise = (delay: number) => ({
  animation: `enc-rise 440ms var(--ease-quint-out) ${delay}ms both`,
});

/**
 * Ouverture du site : la promesse en serif, le paraphe sous « relation », et
 * à côté le dossier d'un client tenu par le trombone du logo.
 */
export function Hero() {
  return (
    <section className="relative isolate overflow-hidden">
      <div
        aria-hidden="true"
        className="bg-ruled absolute inset-x-0 top-0 -z-10 h-[680px] opacity-70"
      />
      <div className="mx-auto grid max-w-[1200px] items-center gap-12 px-4 pt-12 pb-20 sm:px-6 lg:grid-cols-[1.05fr_1fr] lg:gap-10 lg:px-8 lg:pt-12 lg:pb-20">
        <div>
          <p
            className="text-xs font-semibold uppercase tracking-[0.16em] text-action"
            style={rise(0)}
          >
            Relance de factures impayées · Pennylane + Gmail
          </p>
          <h1
            className="mt-5 font-display text-[clamp(2.35rem,4.7vw,3.65rem)] leading-[1.02] font-semibold tracking-[-0.022em] text-balance text-primary"
            style={rise(60)}
          >
            Relancez vos clients.{" "}
            <span className="block">
              Pas votre <Paraphe delay={650}>relation</Paraphe>.
            </span>
          </h1>
          <p
            className="mt-6 max-w-[32rem] text-base sm:text-lg leading-relaxed text-pretty text-muted-foreground"
            style={rise(140)}
          >
            Avec {BRAND}, retrouvez les factures à relancer, écrivez depuis votre
            Gmail et suivez chaque promesse de paiement. Les échanges restent
            attachés au client, même quand la facture change.
          </p>
          <div
            className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center lg:flex-wrap xl:flex-nowrap"
            style={rise(220)}
          >
            <CtaLink to="/signup" arrow>
              Créer un compte
            </CtaLink>
            <CtaLink to="/#fonctionnement" variant="secondary">
              Voir comment ça marche
            </CtaLink>
          </div>
          <p
            className="mt-5 text-ui text-subtle-foreground"
            style={rise(280)}
          >
            Sans carte bancaire · Chaque envoi reste votre décision
          </p>
        </div>

        <DossierScene />
      </div>
    </section>
  );
}
